export const ROUTE_FAMILIES = [
  "home",
  "city",
  "state",
  "request-quote",
  "listing-browse",
  "listing",
  "dashboard",
  "admin",
  "api",
  "other",
] as const;

export type RouteFamily = (typeof ROUTE_FAMILIES)[number];

const FAMILY_PATTERNS: readonly [RouteFamily, RegExp][] = [
  ["home", /^\/$/],
  ["city", /^\/(buy|sell|recycle)-[a-z0-9-]+\/[^/]+\/[^/]+\/?$/],
  ["state", /^\/(buy|sell|recycle)-[a-z0-9-]+\/[^/]+\/?$/],
  ["request-quote", /^\/listing\/[^/]+\/request-quote\/?$/],
  ["listing-browse", /^\/listing(\/category(\/|$)|\/?$)/],
  ["listing-browse", /^\/buy-[a-z0-9-]+\/?$/],
  ["listing", /^\/listing\/[^/]+\/?$/],
  ["request-quote", /^\/request-quote(\/|$)/],
  ["dashboard", /^\/dashboard(\/|$)/],
  ["admin", /^\/admin(\/|$)/],
  ["api", /^\/api(\/|$)/],
];

export function routeFamily(pathname: string): RouteFamily {
  for (const [family, pattern] of FAMILY_PATTERNS) {
    if (pattern.test(pathname)) return family;
  }
  return "other";
}
